import { Component, input, model, OnInit, signal } from '@angular/core';
import { Types } from 'shared-lib';
import { v4 } from 'uuid';
import { TextComponent } from '../text/text.component';

@Component({
  selector: 'ui-true',
  standalone: true,
  imports: [TextComponent],
  templateUrl: './true.component.html',
  styleUrl: './true.component.scss',
})
export class TrueComponent implements OnInit {
  default = model<Types.TChoice>();
  placeHolder = model.required<string>();
  required = input(false);
  value = model<Types.TChoice>();
  editable = input(false);
  isTemplate = input(false);

  uiId = v4();

  constructor() {}

  current = signal<Types.TChoice | undefined>(undefined);

  ngOnInit(): void {
    this.current.set(!!this.value() ? this.value() : this.default());
  }

  // ZONA: isTemlpate

  onPlaceholderChange(inputValue?: Types.TChoice | Types.TChoice[]) {
    this.placeHolder.set(inputValue as string);
  }

  onDefaultChange(inputValue?: Types.TChoice | undefined) {
    this.default.set(inputValue as string);
    this.value.set(inputValue as string);
  }

  resetValue() {
    this.value.set(undefined);
    this.current.set(undefined);
  }

  // ZONA: is Edit

  onChange(target?: any) {
    this.value.set(target.checked);
    this.current.set(this.value());
  }
}
